// components
import { Typography } from '@centria-ui-atoms/typography'

// prime components
import { RadioButton as PrRadioButton } from 'primereact/radiobutton'

// styles
import classes from './styles.module.scss'

// types
import type { RadioButtonProps as PrRadioButtonProps } from 'primereact/radiobutton'
import type { FC } from 'react'

export interface RadioButtonProps extends PrRadioButtonProps {
  label?: string
}

export const RadioButton: FC<RadioButtonProps> = ({
  label,
  className = '',
  ...props
}) => {
  return (
    <div className='d-flex gap-2 align-items-center'>
      <PrRadioButton
        {...props}
        className={`${className} ${classes.radiobutton}`}
      />
      {label && (
        <Typography htmlFor={props.inputId} Tag='label' fontSize='small'>
          {label}
        </Typography>
      )}
    </div>
  )
}
